import { render, staticRenderFns } from "./createPriorityMapping.vue?vue&type=template&id=d2ecfa08"
import script from "./createPriorityMapping.vue?vue&type=script&lang=js"
export * from "./createPriorityMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports